import { render, staticRenderFns } from "./LogsTableModalComponent.vue?vue&type=template&id=73f715da&scoped=true&"
import script from "./LogsTableModalComponent.vue?vue&type=script&lang=js&"
export * from "./LogsTableModalComponent.vue?vue&type=script&lang=js&"
import style0 from "./LogsTableModalComponent.vue?vue&type=style&index=0&id=73f715da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f715da",
  null
  
)

export default component.exports